import {Injectable} from '@angular/core';
import {AbstractModelService} from "../model/abstract-model.service";
import {User} from "../../models/user";
import {ApiClientService} from "../api-client/api-client.service";
import {Observable, Subscriber} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService extends AbstractModelService<User> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/user', User);
  }

  updateCurrent(data: any = {}): Observable<void> {
    return new Observable<void>((subscriber: Subscriber<void>): void => {
      this.apiClient.put(this.routePath + '/current', {}, data).subscribe({
        next: () => {
          subscriber.next();
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  hasRole(user: User, role: string): boolean {
    return user.roles.includes(role);
  }

  addRole(user: User, role: string): void {
    if (!this.hasRole(user, role)) {
      user.roles.push(role);
    }
  }

  removeRole(user: User, role: string): void {
    const i = user.roles.indexOf(role);
    if (i >= 0) {
      user.roles.splice(i, 1);
    }
  }
}
